export default __webpack_public_path__ + "static/media/IMG_Home_Card.856e44e1.png";